import { encodeGetParams } from "../helper/Encypt";
import { apiUrl, customerApi, moderationApi } from "../helper/ApiUrl";
import { Get, Post, Delete, Put } from "../common/httpRestServices";
/**
 * @param  {object} obj
 * add newTeam Mamber
 */
export const addTeamMember = (obj = {}) => {
    const { data: { payload } = {} } = obj || {};
    return Post(`${apiUrl}${customerApi.updateEmployee}`,payload, true);
};

/**
 * @param  {object} obj;
 * initial initial params and search params pass
 * encodeGetParams convert params to query params
 */
export const getMemberListData = (obj = {}) => {
    const { data = {} } = obj || {};
    const queryString = data ? encodeGetParams(data) : null;
    return Get(`${apiUrl}${customerApi.getEmployeesList}${queryString}`, true);
};

/**
 * @param  {array} params;
 * array is index of array
 * it is user id
 */
export const deleteMemberList = (params) => {
    const userId = params?.customerIds[0];
    return Delete(`${apiUrl}${customerApi.updateEmployee}/${userId}`, { userIds: params }, true);
};

/**
 * @param  {object} obj;
 * view single user Details,
 * userId is endPoint
 */
export const getSingleUserDetails = (obj = "") => {
    const { data } = obj || {};
    return Get(`${apiUrl}${customerApi.getEmployeeDetails}${data.customerId}`, true);
};

/**
 * @param  {object} obj;
 * update userDetails,
 * encodeGetParams is Helps to convert query params,
 * inputData->image from input type
 * userInput->input filed
 */
export const updateUserDetail = (obj = {}) => {
    const { data: { payload = {} } = {} } = obj || {};
    return Put(`${apiUrl}${customerApi.updateEmployee}/${payload?.userId}`, payload, true);
};
export const getRoleAccessData = (obj = {}) => {
    const { data = {} } = obj || {};
    const queryString = data ? encodeGetParams(data) : null;
    return Get(`${apiUrl}${customerApi.getRoleAccess}${queryString}`, true);
};
export const getSaveorEditData = (obj = {}) => {
    const { data = {} } = obj || {};

    const headers = {
        'Content-Type': 'application/json',
    };

    return Post(`${apiUrl}${customerApi.saveAndEditRoleAccess}`, JSON.stringify(data), {
        headers,
        body: JSON.stringify(payload),
    });
};
export const getMemberRecentChatData = (obj = {}) => {
    const { data = {} } = obj || {};
    const queryString = data ? encodeGetParams(data) : null;
    return Get(`${apiUrl}${moderationApi.memberRecentChat}${queryString}`, true);
};

export const getMemberChatHistory = (obj = {}) => {
    const { data = {} } = obj || {};
    const queryString = data ? encodeGetParams(data) : null;
    return Get(`${apiUrl}${moderationApi.memberChatHistory}${queryString}`, true);
};
export const chatMediaDownloadService = (obj = {}) => {
    const { data } = obj || {};
    return Post(`${apiUrl}${moderationApi.chatMediaDownload}`, data, true);
};
